import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { useIsMobile } from "@/features/utils/use-mobile";
import { cn } from "@/lib/utils";
import { twMerge } from "tailwind-merge";

export const ResponsiveDialog = ({
  children,
  open,
  onOpenChange,
}: {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        {children}
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {children}
    </Dialog>
  );
};

export const ResponsiveDialogHeader = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <DrawerHeader className={cn("p-4 pt-4", className)}>
        {children}
      </DrawerHeader>
    );
  }

  return (
    <DialogHeader className={twMerge("p-4 pb-0", className)}>
      {children}
    </DialogHeader>
  );
};

export const ResponsiveDialogContent = ({
  children,
  className,
  showCloseButton,
}: {
  children: React.ReactNode;
  className?: string;
  showCloseButton?: boolean;
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <DrawerContent blocking={showCloseButton} className={cn(className)}>
        {children}
      </DrawerContent>
    );
  }

  return (
    <DialogContent
      showCloseButton={showCloseButton}
      className={cn("p-1 pb-6", className)}
    >
      {children}
    </DialogContent>
  );
};

export const ResponsiveDialogTrigger = ({
  children,
  asChild = false,
}: {
  children: React.ReactNode;
  asChild?: boolean;
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <DrawerTrigger asChild={asChild}>{children}</DrawerTrigger>;
  }

  return <DialogTrigger asChild={asChild}>{children}</DialogTrigger>;
};

export const ResponsiveDialogFooter = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <DrawerFooter className={twMerge(className)}>{children}</DrawerFooter>
    );
  }

  return (
    <DialogFooter className={cn("p-4 -mb-6", className)}>
      {children}
    </DialogFooter>
  );
};
